import { render, staticRenderFns } from "./modalofferapprove.vue?vue&type=template&id=70a0a5bf"
import script from "./modalofferapprove.vue?vue&type=script&lang=js"
export * from "./modalofferapprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports